


































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { getOperationID } from '@/api/operations'
import { IMember } from '@/types/member'
import { nickname } from '@/utils/nickname'
import Avatar from '@/components/Profil/Avatar.vue'

@Component({
    components: {
        Avatar,
    },
})
export default class AperMembre extends Vue {
    @Prop() private member: any
    apiService = new ApiService()
    myGroups = []

    identikits = null
    sharedSpaces = null
    comment = null
    familyMembers = null

    inviteSelectedGroup = null

    async mounted() {
        if (UserModule.token === undefined) {
            UserModule.Init()
        }

        const userID = UserModule.userInfos.id

        const opeID = await getOperationID()
        const groupResp = await this.apiService.getGroupsByOperation(opeID)

        this.myGroups =
            groupResp.data.filter((x: any) => {
                for (let i = 0; i < x.users.length; i++) {
                    if (
                        x.users[i].id === userID &&
                        (x.users[i].state === 'member' ||
                            x.users[i].state === 'waiting')
                    ) {
                        return true
                    }
                }
                return false
            }) || []

        const userOpe = this.member.userOperations.find(
            ope => ope.operation.id == opeID
        )

        if (userOpe) {
            this.identikits = userOpe.sharedSpaces
            this.sharedSpaces = userOpe.sharedSpaces
            this.comment = userOpe.comment
            this.familyMembers = userOpe.familyMembers
        }
    }

    get nickname() {
        if (this.member.nickname) {
            return this.member.nickname
        }

        return nickname(this.member.firstname, this.member.lastname)
    }

    inviteUserToGroup() {
        if (this.inviteSelectedGroup) {
            this.apiService
                .inviteUserInGroup(this.inviteSelectedGroup.id, this.member.id)
                .then(() => {
                    this.$emit('invitationResp', true)
                })
                .catch(() => {
                    this.$emit('invitationResp', false)
                })
        }
    }
}
